import React from "react";
import Main from "../components/main";
import MfaVerifyComponent from "../components/mfa-verify";
import config from "../config";

export default function Mfa() {
  return (
    <Main>
      <MfaVerifyComponent
        authUrl={config.auth} 
        portalUrl={config.portal} 
        apiUrl={config.backend}
      />
    </Main>
  );
}
